import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import AlbumOverview from './components/AlbumOverview';
import TimelineSection from './components/TimelineSection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <AlbumOverview />
        <TimelineSection />
      </main>
      <Footer />
    </>
  );
}